import {
	faFileExcel,
	faFileCsv,
	faFolder,
	faFilePowerpoint,
	faLock,
	faUnlock,
	faFile,
	faFileWord,
	faFilePdf,
	faFileImage,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function getFileTypeIcon(filename: string): JSX.Element {
	var extension = filename.split('.').pop()?.toLowerCase();

	switch (extension) {
		case 'ppt':
		case 'pptx':
			return <FontAwesomeIcon icon={faFilePowerpoint} />;
		case 'doc':
		case 'docx':
			return <FontAwesomeIcon icon={faFileWord} />;
		case 'xls':
		case 'xlsx':
			return <FontAwesomeIcon icon={faFileExcel} />;
		case 'csv':
			return <FontAwesomeIcon icon={faFileCsv} />;
		case 'pdf':
			return <FontAwesomeIcon icon={faFilePdf} />;
		case 'img':
		case 'jpg':
		case 'gif':
		case 'tiff':
		case 'png':
		case 'jpeg':
			return <FontAwesomeIcon icon={faFileImage} />;
	}

	return <FontAwesomeIcon icon={faFile} />;
}
